// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCardStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

productGridCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                &.pricing-info-container {
                    margin-top: 8px;
                    .middle-section {
                        margin-top: auto;
                    }
                    .bottom-section {
                        margin-top: 0;
                    }
                }
            `,
        },
    },
    productAvailableStyles: {
        container: {
            css: css`
                margin-bottom: 8px;
                &:has(div:empty) {
                    display: none;
                }
            `,
        },
    },
    addToCartActions: {
        css: css`
            margin-top: 8px;
        `,
    },
    addToCartButton: {
        css: css`
            min-width: 113px;
        `,
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                ${xScreen("lte", "sm")} {
                    max-width: 85px;
                }
            `,
        },
    },
};

productGridCardStyles.imageWrapper = {
    css: css`
        margin-bottom: 12px;
    `,
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            left: 0;
            bottom: 0;
        `,
    },

    productImage: {
        linkWrappingImage: {
            css: css`
                position: relative;
                width: 100%;
                margin: 0 auto;
            `,
        },
        img: {
            width: 317,
            height: 317,
            css: css`
                max-width: 100%;
                max-height: 317px;
                height: auto;
                object-fit: contain;
                font-size: 14px;
            `,
        },
    },
};

productGridCardStyles.productListDefaultImageStyles = {
    ...mergeWithCss(productGridCardStyles.productListImageStyles, {
        productImage: {
            img: {
                css: css`
                    object-fit: fill;
                `,
            },
        },
    }),
};

productGridCardStyles.productInformationStyles = {
    container: {
        gap: 8,
        css: css`
            ${GridItemStyle} {
                &:has(div:empty) {
                    display: none;
                }
            }
        `,
    },
    brandGridItem: {
        css: css`
            padding-top: 0;
            padding-bottom: 2px;
        `,
    },
    descriptionGridItem: {
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    descriptionStyles: {
        productDetailDescription: {
            css: css`
                min-height: 34px;
            `,
        },
        productDetailLink: {
            css: css`
                min-height: 34px;
            `,
        },
    },
};
